/**
 * Regex to check addresses against
 * @type {RegExp}
 */

const addressRegex = /^(?:[\p{L}\p{Mn}\p{Pd}.,'\s\d]+)+$/u

export default addressRegex
